<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { SafeSearchColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()

const iconColor = computed(
    () => theme.global.current.value.dark
        ? SafeSearchColors.icon.dark
        : SafeSearchColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? SafeSearchColors.background.dark
        : SafeSearchColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="PolicyIconSafeSearch"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
